<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 13:16:54
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-27 14:08:19
 * @FilePath: /wemeet-poster/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/components/wmt-image/index.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <div class="wmt-image">
    <div v-if="type == 'img'">
      <el-image class="img" :src="src">
        <template #error>
          <div class="image-slot">
            <el-icon>
              <Picture />
            </el-icon>
          </div>
        </template>
      </el-image>

      <div v-if="src" class="hoveBox">
        <el-icon @click="delImg">
          <Delete />
        </el-icon>
        <el-icon @click="preview">
          <View />
        </el-icon>
      </div>
    </div>

    <div v-else>
      <video class="img" controls :src="src"></video>
      <div v-if="src" class="videoHover">
        <el-icon @click="delImg">
          <Delete />
        </el-icon>
      </div>
    </div>
    <el-image-viewer v-if="showImageViewer" :url-list="[src]" @close="closeViewer" />
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs, watch } from 'vue'
  import { Picture, Delete, View } from '@element-plus/icons'
  export default defineComponent({
    name: 'index.vue',
    props: {
      src: {
        type: String,
        default: '',
      },
    },
    emits: ['deleteImg'],
    setup(props, { emit }) {
      const preview = () => {
        state.showImageViewer = true
      }

      const state = reactive({
        showImageViewer: false,
        type: 'img',
      })

      const closeViewer = () => {
        state.showImageViewer = false
      }

      watch(
        () => props.src,
        (val) => {
          if (!val) return
          const isImg = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(val.split('?')[0])
          if (!isImg) state.type = 'video'
        },
        { immediate: true, deep: true }
      )

      const delImg = () => {
        emit('deleteImg', props.src)
      }
      return {
        ...toRefs(state),
        preview,
        closeViewer,
        delImg,
      }
    },
  })
</script>
<style lang="scss" scoped>
  .wmt-image {
    position: relative;

    &:hover {
      .hoveBox {
        opacity: 1;
      }

      .videoHover {
        opacity: 1;
      }
    }

    .img {
      width: 200px;
      height: 200px;
      margin-right: 20px;
    }

    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 200px;
      height: 200px;
      background: #f5f7fa;
      color: #909399;
      font-size: 30px;
      margin-right: 20px;
    }

    .image-slot .el-icon {
      font-size: 30px;
      color: #909399;
    }

    .hoveBox {
      width: 200px;
      height: 200px;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;

      .el-icon {
        font-size: 20px;
        margin-left: 10px;
        cursor: pointer;
      }

      opacity: 0;
    }

    .videoHover {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;

      .el-icon {
        font-size: 20px;
        margin-left: 10px;
        cursor: pointer;
      }

      opacity: 0;
    }
  }
</style>
